import React from "react";

const Education = () => {
  return (
    <>
      <section className="education-section">
        <h1>Освіта</h1>

        <ul className="education-list">
          <li>
            <h2>Skill-Up </h2>
            <h3>Front-End Development</h3>
            <p>Червень 2021 - Жовтень 2021 | Україна</p>
          </li>
          <li>
            <h3>ЛНУ ім.Івана Франка</h3>
            <h4>Право (Магістр)</h4>
            <p>Вересень 2016 - Червень 2017 | Україна</p>
          </li>
          <li>
            <h3>КНУ ім. Т.Г.Шевченка</h3>
            <h4>Право (Бакалавр)</h4>
            <p>Вересень 2011 - Червень 2016 | Україна</p>
          </li>
        </ul>
      </section>
    </>
  );
};
export default Education;
